import { Helper } from "../../core/util/helper";
import { General } from "../../../siteManagement/general";
import { SheetEventType, Sheet } from "../../../siteManagement/sheet";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { AgreementLevelEntity, AgreementEntity, AgreementMachineEntity } from "./agreement";
import { NotificationHelper } from "../../core/util/notificationHelper";
import LevelApp, { LevelEntity, LevelAppProps } from "../level/level";
import { DialogHelper } from "../../core/util/dialogHelper";
import { HTTPService } from "../../core/util/httpManager";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class AgreementLevelGrid extends React.Component<AgreementMachineGridProps, AgreementMachineGridState> {
    private _gridOptions: kendo.ui.GridOptions = null;
    private _sheet: Sheet = null;
    private _translations: StringKeyDictionary<string> = null;

    constructor(props: AgreementMachineGridProps) {
        super(props);
        this._sheet = General.Sheet.Manager.getTopMostSheet();
        this._translations = this.props.context.translations;
        this._gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "MaschNr",
                    title: this._translations["Field.Maschine.maschnr"],
                    width: 65
                },
                {
                    field: "MaschBezeichnung",
                    title: this._translations["WebSMS.SLA.Maschine"],
                    width: 65
                },
                {
                    field: "MaschNr2",
                    title: this._translations["Field.Maschine.maschnr2"],
                    width: 65
                },
                {
                    field: "MaschTyp",
                    title: this._translations["Field.Maschine.maschtyp"],
                    width: 65
                }
            ]
        }
        this.state = { gridData: props.entity.Machines
            };
    }

    
    
    //private _openPos = (dataItem: AgreementLevelEntity = null) => {
    //    Helper.getMetaData("slaLevel")
    //        .then(result => {
    //            const entity = dataItem;
    //            const metadata = result;
    //            this._initCodeWindow(entity, metadata);
    //        });
    //}

    private _initCodeWindow = (entity: AgreementMachineEntity) => {
        //const props = {
        //    dataSources: {}, metadata: metaData as Metadata, entity: entity, isWindow: true, context: {}, title: ""
        //}
        //const sheet = General.Sheet.Manager.createSheetWithUrl("SlaLevel/Edit?id=" + entity.LevelId);
        //sheet.bind(SheetEventType.Close, (target) => {
        //    // this._getGridData();
        //});
        //sheet.bind(SheetEventType.SavedSuccessfully,
        //    (saved: LevelAppProps) => {
        //        const level = Helper.getArrayItem(this.state.gridData, "LevelId", saved.entity.Id);
        //        if (level != null) {
        //            level.Title = saved.entity.Title;
        //            level.StartEvent.EventTypeStr = saved.entity.StartEvent.EventTypeStr;
        //            level.StartEvent.Status = saved.entity.StartEvent.Status;
        //            level.EndEvent.EventTypeStr = saved.entity.EndEvent.EventTypeStr;
        //            level.EndEvent.Status = saved.entity.EndEvent.Status;
        //            level.ReactionTypeStr = saved.entity.ReactionTypeStr;
        //        }

        //        this.setState({});
        //        /*var item = Helper.getArrayItem(this.props.entity.Positions, "Id", position.Id);
        //        if (item == null) {
        //            item = JSON.parse(JSON.stringify(position));
        //            this.props.entity.Positions.push(item);
        //        } else {
        //            item.TypeOfDay = position.TypeOfDay;
        //            item.StartMinute = position.StartMinute;
        //            item.StartStr = position.StartStr;
        //            item.EndMinute = position.EndMinute;
        //            item.EndStr = position.EndStr;
        //        }
        //        // die Positionen müssen immer nach TypeOfDay, StartMinute sortiert sein.
        //        //   die Sortierung muss auch nach dem Edit vorgenommen werden (da der TypeOfDay bzw. StartMinute sich geändert haben könnte)
        //        this.props.entity.Positions.sort((a, b) => { return a.TypeOfDay == b.TypeOfDay ? a.StartMinute - b.StartMinute : a.TypeOfDay - b.TypeOfDay});
        //        this.updateTypeOfStr(item, this.props.context.TypesOfDay);
        //        this.props.onChange(this.props.field, item.Id);
        //        */
        //    });

        //sheet.show(() => {
        //    //sheet.mountContent(LevelApp, props);
        //    //sheet.mountContent(ServiceHoursPos, props);
        //});
    }


    private _deleteLevel = (id: string) => {

       DialogHelper.confirm(this.props.field.customProps["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let item = Helper.findObjIndex(this.props.entity.Machines, "MaschNr", id);
                if (item >= 0) {
                    this.props.entity.Machines.splice(item, 1);
                    this.setState({gridData: this.props.entity.Machines});
                    this.props.onChange({ model: "entity.Machines" }, this.props.entity.Machines);
                }
            }
        });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: AgreementMachineEntity) => {
        if (type == ToolBarStandardButtonType.NEW) {
            const url = "DynamicSearch/Window/Machine/?multi=true&displayPattern=[[maschnr]] [[maschbezeichnung]]&adrnr=" + this.props.entity.PartnerAddressNumber;
            const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
            //sheet.setTitle(this._translations["Maschine.Maschinensuche"]);
            sheet.bind(SheetEventType.ItemsSelected, (ev) => {
                const data = ev.data;
                if (data.length > 0) {
                    let added = false;
                    console.table(data);
                    let gridData = this.state.gridData;
                    for (var row of data) {
                        if (gridData.filter(x => x.MaschNr == row.maschnr).length == 0) {
                            let abc = Helper.createEmptyEntity() as AgreementMachineEntity;
                            abc.MaschNr = row.maschnr;
                            abc.MaschBezeichnung = row.maschbezeichnung;
                            abc.MaschNr2 = row.maschnr2;
                            abc.MaschTyp = row.maschtyp;
                            gridData.push(abc);
                            added = true;
                        }
                    }
                    
                    if (added){
                        this.setState({gridData: gridData});
                        this.props.onChange({ model: "entity.Machines" }, this.state.gridData);
                    }
                }

                //const data = ev.data;
                //if (data.length > 0) {
                    /*const includeReferences = await DialogHelper.confirm(this._translations["WebSMS.Project.AddAssignedMachines"]);
                    HTTPService.post<JsonResultClass>('ProjectMachine/AddMachines', { id: this.props.entity.Projnr, machines: data, includeReferences: includeReferences })
                        .then(result => {
                            if (result.Code === 0) {
                                this._getGridData();
                            } else {
                                NotificationHelper.showSuccessMessage(result.Message);
                            }
                        });*/
                //}
            });
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this._deleteLevel(dataItem.MaschNr);
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.add, enabled: this.props.entity.RecordRight.CanWrite });
        //standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: "Configure", enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.props.entity.RecordRight.CanWrite });

        let grid = (
            <Grid data={this.state.gridData} options={this._gridOptions} id="agreementMachinesGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
        );
        return (grid)
    }


    componentDidMount() {
        //this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>                    
                    {grid}
                </div>
            </div>);

    }
};

interface AgreementMachineGridProps {
    context: {TypesOfDay:KeyValuePair<number, string>[], translations: StringKeyDictionary<string>};
    translations: StringKeyDictionary<string>;
    field: any;
    entity: AgreementEntity;
    onChange: (field, value) => void
}

interface AgreementMachineGridState {
    gridData: AgreementMachineEntity[];
}